export default __webpack_public_path__ + "static/media/search_icon.4a1e8110.svg";